export const FETCH_CHALLENGES = {
  START: 'START_FETCH_CHALLENGES',
  COMPLETE: 'COMPLETE_FETCH_CHALLENGES',
  FAIL: 'FAIL_FETCH_CHALLENGES',
  CLEANUP: 'CLEANUP_FETCH_CHALLENGES',
}

export const ADD_CHALLENGE = 'ADD_CHALLENGE'
export const RENAME_CHALLENGE = 'RENAME_CHALLENGE'
export const RESET_CHALLENGE_TREE = 'RESET_CHALLENGE_TREE'

export const SET_DATA_FOR_RENAMING_CHALLENGE = 'SET_DATA_FOR_RENAMING_CHALLENGE'

export const DELETE_CHALLENGE = {
  START: 'START_DELETE_CHALLENGE',
  COMPLETE: 'COMPLETE_DELETE_CHALLENGE',
  FAIL: 'FAIL_DELETE_CHALLENGE',
}

export const SAVE_CHALLENGES = {
  START: 'START_SAVE_CHALLENGES',
  COMPLETE: 'COMPLETE_SAVE_CHALLENGES',
  FAIL: 'FAIL_SAVE_CHALLENGES',
}
